<template>
    <v-date-picker
        v-model="model"
        multiple
        no-title
        first-day-of-week="1"
        locale="es-cl"
        :show-current="false"
        disabled
        :weekday-format="weekDays"
        class="container-date-picker"
    />
</template>

<script>
export default {
    name: "MiniCalendarAdvance",
    data(vm) {
        return {
            model: null,
            days: [
                vm.$t('days.short_sunday'),
                vm.$t('days.short_monday'),
                vm.$t('days.short_tuesday'),
                vm.$t('days.short_wednesday'),
                vm.$t('days.short_thursday'),
                vm.$t('days.short_friday'),
                vm.$t('days.short_saturday'),
            ],
            dates: [],
        }
    },
    mounted() {
        const vm = this
        // Adaptar las fechas a solo el numero del dia
        vm.dates = [
            {date: '2022-08-19', day: '19', color: '#99CC00'},
            {date: '2022-08-20', day: '20', color: '#767f5a'},
            {date: '2022-08-26', day: '26', color: '#2c00cc'},
        ]
        vm.setColors();
    },
    methods: {
        weekDays(day) {
            const vm = this
            return vm.days[vm.$moment(day).day()]
        },
        setColors() {
            const vm = this
            let allDates = document.querySelectorAll(".v-date-picker-table .v-btn .v-btn__content")
            let days = vm.dates.map(date => date.day)
            allDates.forEach(x => {
                if (days.includes(x.innerHTML)) {
                    let color = vm.dates.find(date => date.day === x.innerHTML).color
                    x.parentNode.style = `background-color: ${color} !important; color: #FFFFFF !important;`
                }
            })
        },
    }
}
</script>

<style scoped>

.container-date-picker {
    padding: 12px 0;
    background-color: transparent !important;
}

::v-deep .v-picker__body {
    background: none;
}

/*Sin mes ni año*/
::v-deep .v-date-picker-header {
    display: none
}

/*Cuerpo del datepicker completo*/
::v-deep .v-date-picker-table {
    height: 100%;
}

/*Text de los dias*/
::v-deep thead > tr > th {
    font-weight: 400 !important;
    font-size: 13px !important;
    line-height: 13px !important;
    color: #99CC00 !important;
}

::v-deep tbody > tr > td .v-btn--active:before {
    font-weight: 800 !important;
    font-size: 16px !important;
    line-height: 19px !important;
    border-radius: 0;
    width: 100%;
    opacity: 0;
}

::v-deep .v-btn.v-btn--disabled {
    color: #333333 !important;
    background-color: #FFFFFF;
    border-radius: 0;
}

</style>